// extracted by mini-css-extract-plugin
export default {"chip":"CustomChip_chip__SvWB+","chipLabels":"CustomChip_chipLabels__-yjnE","customChipCls":"CustomChip_customChipCls__gPnRw"};